<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">{{ $t('setting.conditions') }}</h3>
      </div>

      <div id="kt_content_container" class="container-xxl">
        <div class="card mb-5 mb-xxl-8">
          <div class="card-body pt-9 pb-0">
            <!-- Navigation des tabs -->
            <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder">
              <li class="nav-item mt-2 text-active-primary" v-for="tab in tabs" :key="tab.name">
                <router-link
                    :to="{ name: tab.routeName }"
                    class="nav-link"
                    :class="{
      active: $route.name === tab.routeName || (!$route.name && index === 0)
    }"                >
                  {{ tab.label }}
                </router-link>
              </li>

            </ul>


            <!-- Contenu via router-view -->
            <div class="mt-4">
              <router-view />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";

// Définition des tabs
const tabs = [
  { name: "cgv", label: "CGV", routeName: "setting-system-cgv" },
  { name: "privacy", label: "Politique de confidentialité", routeName: "setting-system-privacy" },
  { name: "refund", label: "Retours & Remboursements", routeName: "setting-system-refund-policy" },
  { name: "legal", label: "Mentions légales", routeName: "setting-system-legal-policy" },
  { name: "delivery", label: "Délai de livraison", routeName: "setting-system-delivery-delay" },
];


// Pour gérer l’onglet actif
const route = useRoute();
const isActive = (tabRoute) => route.path === tabRoute;
</script>

